export default "__VITE_ASSET__ajEbT2y3__"